/* src/app/documents/poll/poll.component.scss */
/*# sourceMappingURL=poll.component.css.map */
